import styled, { css } from "styled-components";

import H4 from "../../components/atoms/Typography/H4";

export const Content = styled.div`
  gap: 20px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  width: fit-content;
  transform: rotate(180deg);
  justify-content: flex-start;
`;

export const BuyCredits = styled.div`
  top: 20vh;
  gap: 32px;
  width: 100%;
  display: flex;
  padding: 8px 16px;
  border-radius: 12px;
  flex-direction: column;
  background-color: #fafafa;

  button {
    align-self: end;
    max-width: 200px;
    margin-top: 120px;
  }

  @media (max-width: 820px) {
    padding: 8px 0;
  }

  @media (max-width: 780px) {
    button {
      margin-top: 56px;
    }
  }

  @media (max-width: 520px) {
    button {
      max-width: 160px;
    }
  }
`;

export const ProjectsSelector = styled.div`
  width: 100%;
  display: flex;
`;

export const Projects = styled.div`
  display: flex;
  margin-top: 40px;
  flex-direction: column;
`;

type TitleCustomProps = {
  width: string;
  marginLeft?: string;
};

export const TitleCustom = styled(H4)<TitleCustomProps>`
  ${({ width, marginLeft }) => css`
    width: ${width};
    padding-left: 20px;
    margin-left: ${marginLeft && marginLeft};

    sub {
      font-size: 1.2rem;
      font-weight: bold;
    }

    @media (max-width: 820px) {
      padding-left: 0;
    }

    @media (max-width: 640px) {
      font-size: 1rem;

      sub {
        font-size: 0.9rem;
      }
    }

    @media (max-width: 520px) {
      font-size: 0.8rem;

      sub {
        font-size: 0.75rem;
      }
    }
  `}
`;

export const HeaderProjects = styled.div`
  display: flex;
  padding-bottom: 8px;
`;

type ProjectsProps = {
  borderColor: string;
  bothBorders: boolean;
};

export const ProjectsList = styled.div<ProjectsProps>`
  ${({ borderColor, bothBorders }) => css`
    gap: 40px;
    display: flex;
    padding: 16px 0;
    margin-top: 16px;
    flex-direction: column;
    border-top: 1px solid ${borderColor};
    border-bottom: ${bothBorders && `1px solid ${borderColor}`};

    h3 {
      padding-left: 20px;
    }
  `}
`;

export const Project = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
`;

type QuantityBoxProps = {
  width: string;
};

export const QuantityBox = styled.div<QuantityBoxProps>`
  ${({ width }) => css`
    display: flex;
    width: ${width};
    min-width: 100px;

    .div {
      width: 50%;
    }

    @media (max-width: 520px) {
      min-width: 80px;
    }
  `}
`;

export const RemoveIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Total = styled.div`
  display: flex;
  margin-top: 16px;
  align-items: center;
  justify-content: space-between;
`;

type WidthProps = {
  width: string;
};

export const TotalValue = styled(H4)<WidthProps>`
  ${({ width }) => css`
    width: ${width};
    padding-left: 20px;

    @media (max-width: 820px) {
      padding-left: 0;
    }

    @media (max-width: 640px) {
      font-size: 1rem;
    }

    @media (max-width: 520px) {
      font-size: 0.8rem;
    }
  `}
`;

export const Plan = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PlanDescription = styled.div`
  gap: 28px;
  display: flex;
  line-height: 1.3;
  text-align: justify;
  padding: 20px 12px 0;
  flex-direction: column;
`;

export const Classification = styled.div`
  gap: 20px;
  display: flex;
  flex-direction: column;
`;
